<app-error-code-table-search
  (searchTriggered)="onSearchTriggered($event)"
  [recyclingModeEnabled]="recyclingModeEnabled"
></app-error-code-table-search>
<div
  #scrollContainer
  class="relative overflow-x-auto shadow-md sm:rounded-lg max-h-screen-200 min-h-screen-200 overflow-y-auto mt-2"
>
  <table class="w-full text-sm text-left rtl:text-right text-gray-500">
    <thead class="text-xs uppercase bg-amazone-orange text-gray-100 sticky top-0">
      <tr>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'ErrorCode'"
            [field]="getPropertyName('code')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('code'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">Message</th>
        <th scope="col" class="px-6 py-3">NwNumbers</th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Tr. UT'"
            [field]="getPropertyName('translationStateTerminal')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('translationStateTerminal'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Tr. DOC'"
            [field]="getPropertyName('translationStateDocumentation')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('translationStateDocumentation'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Last Update'"
            [field]="getPropertyName('modifiedOn')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('modifiedOn'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Needs Review'"
            [field]="getPropertyName('needsReview')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('needsReview'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">Actions</th>
      </tr>
    </thead>
    <tbody>
      @if (errorCodes?.length === 0) {
        <tr>
          <td class="px-6 py-4 text-center font-medium text-amazone-orange whitespace-nowrap" colspan="7">
            No Error Codes found
          </td>
        </tr>
      }
      @for (errorCode of errorCodes; track $index) {
        <tr
          (click)="onErrorCodeClicked($safeNavigationMigration(errorCode?.id))"
          [ngClass]="
            isSelected($safeNavigationMigration(errorCode?.id))
              ? 'bg-orange-100 sticky top-14 bottom-0 text-amazone-orange translated-x-1 border-l-4 border-amazone-orange'
              : 'odd:bg-white even:bg-gray-50 hover:bg-gray-100 hover:text-amazone-orange border-b border-gray-200 '
          "
          class="transition-all duration-150"
        >
          <td class="px-6 py-4 font-semibold whitespace-nowrap cursor-pointer">
            {{ errorCode?.displayId ?? 'N/A' }}
          </td>

          <td class="px-6 py-4 whitespace-nowrap cursor-pointer">
            {{ commonUtils.truncateString(errorCode?.message ?? '', 50) }}
          </td>

          <td class="px-6 py-4 cursor-pointer whitespace-nowrap">
            {{ errorCode?.nwNumbersString ?? '' }}
          </td>
          <td class="px-6 py-4 cursor-pointer">
            <span
              class="ml-2.5 inline-block size-2.5 shrink-0 rounded-full"
              [ngClass]="
                commonUtils.translationStateToColor($safeNavigationMigration(errorCode?.translationStateTerminal))
              "
              title="{{
                commonUtils.friendlyTranslationState($safeNavigationMigration(errorCode?.translationStateTerminal))
              }}"
            >
            </span>
          </td>
          <td class="px-6 py-4 cursor-pointer">
            <span
              class="ml-2.5 inline-block size-2.5 shrink-0 rounded-full"
              [ngClass]="
                commonUtils.translationStateToColor($safeNavigationMigration(errorCode?.translationStateDocumentation))
              "
              title="{{
                commonUtils.friendlyTranslationState($safeNavigationMigration(errorCode?.translationStateDocumentation))
              }}"
            >
            </span>
          </td>
          <td class="px-6 py-4 cursor-pointer whitespace-nowrap">
            {{ $safeNavigationMigration(errorCode?.modifiedOn) | date: 'yyyy.MM.dd HH:mm' }}
          </td>
          <td class="px-6 py-4 cursor-pointer">
            @if (errorCode.needsReview ?? false) {
              <app-check-icon></app-check-icon>
            } @else {
              <span class="ms-1"></span>
            }
          </td>

          <td class="px-6 py-4">
            <div class="w-5 grid grid-cols-2 gap-10">
              @if (recyclingModeEnabled) {
                <button
                  [appEnabledByPolicy]="[policy.canDeleteHardLegacy, hardDeleteDisabled]"
                  (click)="
                    showDecisionModal(errorCode.id, errorCode.displayId);
                    deleteDecisionModal.openModal();
                    $event.stopPropagation()
                  "
                  type="button"
                  class="font-medium text-red-400 disabled:text-gray-400 hover:text-red-600 cursor-pointer hover:scale-110 disabled:cursor-not-allowed"
                  [disabled]="hardDeleteDisabled"
                  appAgentAction
                  [agent]="'error-code-hard-delete-' + errorCode.id"
                  businessObject="errorCode"
                  [businessId]="errorCode.id"
                  action="delete"
                >
                  <app-delete-icon></app-delete-icon>
                </button>
                <button
                  [appEnabledByPolicy]="[policy.canDeleteSoftAndRestoreLegacy, restoreDisabled]"
                  (click)="
                    restoreErrorCode.emit({ errorCode: errorCode ?? '', query: query }); $event.stopPropagation()
                  "
                  type="button"
                  class="font-medium text-blue-400 disabled:text-gray-400 hover:text-blue-600 cursor-pointer hover:scale-110 disabled:cursor-not-allowed"
                  [disabled]="restoreDisabled"
                  appAgentAction
                  [agent]="'error-code-restore-' + errorCode.id"
                  businessObject="errorCode"
                  [businessId]="errorCode.id"
                  action="restore"
                >
                  <app-restore-icon></app-restore-icon>
                </button>
              } @else {
                <button
                  type="button"
                  [appEnabledByPolicy]="[policy.canDeleteSoftAndRestoreLegacy, softDeleteDisabled]"
                  (click)="
                    showDecisionModal(
                      $safeNavigationMigration(errorCode?.id),
                      $safeNavigationMigration(errorCode?.displayId)
                    );
                    softDeleteDecisionModal.openModal();
                    $event.stopPropagation()
                  "
                  class="font-medium text-red-400 disabled:text-gray-400 hover:text-red-600 cursor-pointer hover:scale-110 disabled:cursor-not-allowed"
                  appAgentAction
                  [agent]="'error-code-deactivate-' + errorCode.id"
                  businessObject="errorCode"
                  [businessId]="errorCode.id"
                  action="deactivate"
                >
                  <app-delete-icon></app-delete-icon>
                </button>
              }
              @if (errorCode?.internalNotes) {
                <app-note-icon class="text-orange-300"></app-note-icon>
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<app-decision-modal
  #softDeleteDecisionModal
  (decision)="onSoftDeleteDecision($event)"
  [entityId]="$safeNavigationMigration(ecToRemove?.id)"
  [entityName]="$safeNavigationMigration(ecToRemove?.displayId)"
  [businessObject]="'errorCode'"
  [header]="'Deactivation of'"
  [details]="['This ErrorCode will not be permanently deleted, but only deactivated. Do you want to proceed?']"
></app-decision-modal>
<app-decision-modal
  #deleteDecisionModal
  (decision)="onHardDeleteDecision($event)"
  [entityId]="$safeNavigationMigration(ecToRemove?.id)"
  [entityName]="$safeNavigationMigration(ecToRemove?.displayId)"
  [businessObject]="'errorCode'"
  [header]="'Deletion of'"
  [details]="['This Error Code will be permanently deleted. Do you want to proceed?']"
></app-decision-modal>
